import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import OptionChainModal from "../../modals/OptionChainModal";
import { useLtpContext } from "../../context/LtpContext";
import WebsocketWrapperContext from "../../context/WebsocketWrapperContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToastContent from "../../components/CustomToastContent";
import SuccessIcon from "../../images/success_icon.svg";
import ErrorIcon from "../../images/error_icon.svg";
import { useFundsData } from "../../context/FundsDataContext";
import MetricsComputations from "../../components/MetricsComputations";
import { ButtonContext } from "../../context/ButtonsContext";
import "../../css/buttonmodal.css";
import { useNavigate, useParams } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useTheme } from "../../context/ThemeContext";
import { useOverlay } from "../../context/OverlayContext";
import OcIcon from "../../images/Builder/option_chain.svg";
import AutoFindIcon from "../../images/Builder/auto_find.svg";
import Tabs from "./components/Tabs";
import Basket from "./components/Basket";
import { useApplyPreBuiltStrategy } from "./helpers/ApplyPrebuilt";
import MarginAndFundsCard from "./components/MarginAndFundsCard";
import StrategyMenu from "../../components/StrategyMenu";
import StrategyGraph from "../../components/StrategyGraph";
import { formatNumberWithCommasAndFontWeight } from "./helpers/formatNumber";
import ConfirmStrategyModal from "./components/ComfirmModal";
import generateOrderPayload from "./helpers/generate_orders_payload";
import sendOrder from "./helpers/send_order";
import PayoffGraph from "../Payoff/PayoffGraph";
import { useOptionChainContext } from "../../context/OptionChainContext";
import { useBuilderContext } from "../StrategyCreator/context/BuilderContext";
import { useOptionChainScreenContext } from "./context/OptionChainContext";
import PayoffSimulations from "./components/PayoffSimulations";
import OptionChainTable from "../../components/OptionChainTable";
import ExpiryDropdown from "./components/ExpiryDropdown";
import Configure from "./components/Configure";
import { getCookie } from "../../utils/cookieUtils";

let triggerSubscribe = true;
let connectionEstablised = false;

const OptionChainScreen = () => {
  const { applyPreBuiltStrategy } = useApplyPreBuiltStrategy();
  const {
    setRows,
    selectedSymbol,
    selectedData,
    symbolsSelectedStrategy,
    setSymbolsSelectedStrategy,
    setLimitOrderStates,
    lotxMap,
    handleLotxChange,
    handleMarketTypeChange,
    marketType,
    limitOrderStates,
    clearBasket,
    selectedExpiry,
    setSelectedExpiry,
    currentOptionsData,
    rows,
    configureSettingsMap,
    setConfigureSettingsMap,
  } = useOptionChainScreenContext();
  const { allOptionsData } = useBuilderContext();
  const { theme } = useTheme();
  const [objectData, setObjectData] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const { isOverlayActive, showOverlay, hideOverlay } = useOverlay();
  const [showCalls, setShowCalls] = useState(true);
  const [showPuts, setShowPuts] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentOptionsCopy, setCurrentOptionsCopy] = useState({});
  const [symbols, setSymbols] = useState([]);
  const [optionData, setOptionData] = useState(null);
  const [tempOptionData, setTempOptionData] = useState({});
  const [allOptionData, setAllOptionData] = useState({});
  const [allTradingSymbols, setAllTradingSymbols] = useState({});
  const [selectedData1, setData] = useState([]);
  const [activeDate, setActiveDate] = useState("");
  const [activeCategory, setActiveCategory] = useState("bullish");

  const [openModal, setOpenModal] = useState(false);
  const [inputValues, setInputValues] = useState([]);
  const [calls, setCalls] = useState([]);
  const [puts, setPuts] = useState([]);
  const [showDelta, setShowDelta] = useState(false);
  const [showTheta, setShowTheta] = useState(false);
  const [showGamma, setShowGamma] = useState(false);
  const [showVega, setShowVega] = useState(false);
  const [showOIChng, setShowOIChng] = useState(false);
  const [showOIBuilddup, setShowOIBuilddup] = useState(false);
  const [support, setSupport] = useState(0);
  const [resistance, setResistance] = useState(0);
  const [maxPain, setMaxPain] = useState(0);
  const [trend, setTrend] = useState({});
  const [rotate, setRotate] = useState(false);
  const [greeksJson, setGreeksJson] = useState([]);
  const navigate = useNavigate();
  const {
    checkWebsocketConnection,
    subscribeToSymbols,
    unsubscribeToSymbols,
    symbolList,
    symbolData,
  } = useContext(WebsocketWrapperContext);
  const { fundsData, fetchBalanceAPI } = useFundsData();
  const broker = localStorage.getItem("broker");
  const access_token = getCookie("access_token");
  const client_id = getCookie("client_id");
  var iv = require("implied-volatility");
  var greeks = require("greeks");

  const metricsComputations = MetricsComputations();
  const [computedData, setComputedData] = useState();

  const handleToastToNavigate = (response) => {
    navigate(response.page);
    // // console.log("Clicked");
  };
  useEffect(() => {
    connectionEstablised = checkWebsocketConnection();
    if (connectionEstablised && symbols.length > 0) {
      if (triggerSubscribe) {
        subscribeToSymbols(symbols, "NSE");
        if (Object.keys(symbolList).length !== 0) {
          triggerSubscribe = false;
        }
      }
    } else {
      triggerSubscribe = true;
    }
  }, [symbolData]);

  const getCodeTradingSymbolMappings = (data, key) => {
    const codeTradingSymbol = [];
    for (const item of data) {
      const { code } = item[key];
      codeTradingSymbol.push(code);
    }
    return codeTradingSymbol;
  };

  useEffect(() => {
    if (
      currentOptionsData[selectedExpiry] &&
      currentOptionsData[selectedExpiry].options
    ) {
      let callsdata = currentOptionsData[selectedExpiry].options.map(
        (option) => option.call
      );
      let putsdata = currentOptionsData[selectedExpiry].options.map(
        (option) => option.put
      );
      setCalls(callsdata);
      setPuts(putsdata);
      const call = getCodeTradingSymbolMappings(
        currentOptionsData[selectedExpiry].options,
        "call"
      );
      const put = getCodeTradingSymbolMappings(
        currentOptionsData[selectedExpiry].options,
        "put"
      );
      const tradingSymbols = call.concat(put);
      subscribeToSymbols(
        tradingSymbols,
        currentOptionsData[selectedExpiry].options[0]?.call?.exchange
      );
    }
  }, [currentOptionsData[selectedExpiry]]);

  useEffect(() => {
    if (optionData && optionData.options) {
      const strikeOpenInterest = {};
      let callMaxOi = 0;
      let putMaxOi = 0;
      let support = 0;
      let resistance = 0;
      // Iterate through the options array and accumulate open interest
      optionData.options.forEach((option) => {
        const callOi = parseFloat(symbolData[option.call.code]?.oi);
        const putOi = parseFloat(symbolData[option.put.code]?.oi);
        let spot = parseFloat(symbolData[selectedSymbol?.code]?.ltp);
        if (callOi > callMaxOi && spot < parseFloat(option.strike)) {
          callMaxOi = callOi;
          resistance = option.strike;
        }
        if (putOi > putMaxOi && spot > parseFloat(option.strike)) {
          putMaxOi = putOi;
          support = option.strike;
        }
        if (!strikeOpenInterest[option.call.strike]) {
          strikeOpenInterest[option.call.strike] = { callOi: 0, putOi: 0 };
        }

        strikeOpenInterest[option.call.strike].callOi += callOi;
        strikeOpenInterest[option.call.strike].putOi += putOi;
      });
      setResistance(resistance);
      setSupport(support);
      let maxPainStrike = null;
      let maxTotalOi = 0;

      for (const strike in strikeOpenInterest) {
        const { callOi, putOi } = strikeOpenInterest[strike];
        const totalOi = callOi + putOi;

        if (totalOi > maxTotalOi) {
          maxTotalOi = totalOi;
          maxPainStrike = strike;
        }
      }
      if (maxPainStrike) {
        setMaxPain(maxPainStrike);
      }
    }
  }, [optionData, symbolData, maxPain]);

  const lastLtpRef = useRef();

  useEffect(() => {
    const currentLtp = symbolData[selectedSymbol?.code]?.ltp;
    if (selectedData?.length === 0) {
      setComputedData(null);
    }
    if (
      selectedData?.length > 0 &&
      selectedSymbol &&
      selectedSymbol.option_expiries?.length > 0 &&
      currentOptionsData[selectedExpiry]?.options?.[0]?.call
    ) {
      lastLtpRef.current = currentLtp;
      const fetchData = async () => {
        try {
          const metrics = await metricsComputations.computeXandYAxis({
            transformedSelectedData: selectedData,
            ltp: currentLtp,
            symbol: selectedSymbol,
            leastExpiry: selectedSymbol.option_expiries[0],
            lotsVal:
              currentOptionsData[selectedExpiry].options[0].call.lot_size,
            currentOptionsData,
            selectedExpiry,
          });
          setComputedData(metrics);
        } catch (error) {
          console.error("Error computing metrics:", error.message);
        }
      };

      fetchData();
    }
  }, [selectedData, selectedSymbol]);

  function getDifference(value1, value2) {
    return Math.abs(value1 - value2);
  }

  const handleScreenerback = async (rowData) => {
    setSymbolsSelectedStrategy((prev) => ({
      ...prev,
      [selectedSymbol.scrip]: null,
    }));
    let filtered_rows = [];
    rowData.map((item, index) => {
      if (item.hasTick) {
        let row = item.data;
        let targetValue = row.inputValue;
        if (
          row.selectedCondition == "delta" ||
          row.selectedCondition == "theta" ||
          row.selectedCondition == "gamma" ||
          row.selectedCondition == "vega"
        ) {
          targetValue = targetValue / 100;
          let closestJson = currentOptionsData[selectedExpiry].options.reduce(
            (prev, curr) => {
              let prev_data = row.isCALL ? prev.call : prev.put;
              let curdd_data = row.isCALL ? curr.call : curr.put;
              const prevDiff = getDifference(
                Math.abs(prev_data.delta),
                targetValue
              );
              const currDiff = getDifference(
                Math.abs(curdd_data.delta),
                targetValue
              );
              return currDiff < prevDiff ? curr : prev;
            }
          );
          let selected_row = row.isCALL ? closestJson.call : closestJson.put;

          let addingRow = {
            buy_sell: row.isBuy ? "Buy" : "Sell",
            code: selected_row.code,
            expiryDate: selected_row.expiry_date,
            instrumentName: selected_row.instrument_name,
            lotSize: selected_row.lot_size,
            side: row.isCALL ? "Call" : "Put",
            tradingSymbol: selected_row.trading_symbol,
            quantity: row.lotsValue,
            freeze_qty: selected_row.freeze_qty,
            exchange: selected_row.exchange,
            strike: parseInt(selected_row.strike),
            lot_multiplier: selected_row.lot_size,
          };
          filtered_rows.push(addingRow);
        }
      }
    });
    if (filtered_rows.length > 0) {
      handleCallback([filtered_rows]);
      toast.success(
        <CustomToastContent
          heading="Instruments identified successfully!"
          message="Instrument added to the basket and analytics updated successfully."
        />,
        {
          className: "custom-success-toast",
          icon: <img src={SuccessIcon} alt="Success Icon" />,
        }
      );
    } else {
      toast.error(
        <CustomToastContent
          heading="Instruments not found!"
          message="Instruments with required combinations not found, please add from option chain"
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
    }
  };

  const callBackToUpdateAlloption = (newOptions) => {
    let date = newOptions?.options[0]?.call?.expiry_date;
    let optdt = newOptions;
    setAllOptionData((prevStatus) => ({
      ...prevStatus,
      [date]: optdt,
    }));
  };

  const handleCallback = async ([rowData], should_add) => {
    let rows = [];
    for (let index = 0; index < rowData?.length; index++) {
      let childData = rowData[index];
      let dataToAdd = childData;
      await subscribeToSymbols([childData.code], childData.exchange);
      let dt = dataToAdd.instrumentName.split(" ");
      let date = dataToAdd.expiryDate;
      const dDate = date.replaceAll("%20", " ");
      const newObject = {
        isBuy: childData.buy_sell == "Buy" ? true : false,
        isCALL: childData.side == "Call" ? true : false,
        strike: parseInt(childData.strike),
        expiry: dDate,
        scrip: dt[0],
        lotSize: childData.quantity,
        code: childData.code,
        tradingSymbol: childData.tradingSymbol,
        allstrks: [],
        allData: [],
        freeze_qty: childData.freeze_qty,
        exchange: childData.exchange,
        lot_multiplier: childData.lot_multiplier,
        instrumentName: childData?.instrumentName,
        orderType: "MARKET",
        price: "",
        isSelected: true,
        isEdit: false,
        productType: "NRML",
        isNewRow: true,
      };
      const newobj = [newObject.code];
      setSymbols(newobj);

      const formattedDate = newObject.expiry.replaceAll(" ", "%20");
      let alldt;
      if (optionData?.id !== selectedSymbol.scrip + newObject.expiry) {
        alldt = allOptionsData[selectedSymbol.scrip][newObject.expiry];
      }
      setTimeout(() => {
        let allstrk = extractStrikeValues(alldt);
        newObject.allstrks = allstrk;
        newObject.allData = alldt?.options;
      }, 200);
      rows.push(newObject);
    }
    const scrip = selectedSymbol.scrip;
    setRows((prev) => {
      const existing = prev[scrip] || [];
      const updatedRows = should_add ? [...existing, ...rows] : rows;
      return {
        ...prev,
        [scrip]: updatedRows,
      };
    });
  };

  const handleCallback2 = async ([childData, buy_sell]) => {
    // Update the name in the component's state
    let dataToAdd = childData;
    let dt = dataToAdd.instrumentName.split(" ");
    let date = dataToAdd.expiryDate;
    const dDate = date.replaceAll("%20", " ");
    const newObject = {
      isBuy: buy_sell == "B" ? true : false,
      isCALL: childData.side == "Call" ? true : false,
      strike: parseInt(childData.strike),
      scrip: dt[0],
      lotSize: childData.lotSize,
      code: childData.code,
      tradingSymbol: childData.tradingSymbol,
      allstrks: [],
      allData: [],
      freeze_qty: childData.freeze_qty,
      exchange: childData.exchange,
      lot_multiplier: childData.lot_multiplier,
      strike: childData.strike,
      expiry: childData.expiryDate,
      tradingSymbol: childData.tradingSymbol,
      lot_multiplier: childData.lot_multiplier,
      scrip: childData.scrip,
      isNewRow: true,
      price: childData?.price,
      orderType: childData?.orderType
    };
    // // console.log(newObject);
    setObjectData(newObject);
    const newobj = [newObject.code];
    setSymbols(newobj);
    // updateSymbol();
    const formattedDate = newObject.expiry.replaceAll(" ", "%20");
    let alldt;
    alldt = allOptionsData[selectedSymbol.scrip][newObject.expiry];

    setTimeout(() => {
      let allstrk = extractStrikeValues(alldt);
      newObject.allstrks = allstrk;
      newObject.allData = alldt?.options;
      const scrip = selectedSymbol.scrip;
      setRows((prev) => {
        const existing = prev[scrip] || [];
        const updatedRows = [...existing, newObject];
        return {
          ...prev,
          [scrip]: updatedRows,
        };
      });
    }, 200);
  };

  useEffect(() => {
    let change = false;
    selectedData?.forEach((row) => {
      if (symbolData[row.code] && !row.price && row.isNewRow) {
        row.price = symbolData[row.code]?.ltp;
        if (!row.price) {
          row.price = symbolData[row.code]?.prev_close;
        }
        row.isNewRow = false;
        change = true;
      }
    });
    if (change) {
      setRows((prev) => {
        return {
          ...prev,
          [selectedSymbol?.scrip]: selectedData,
        };
      });
    }
  }, [selectedData, symbolData]);

  const computeGreeks = () => {
    if (!Array.isArray(selectedData) || selectedData.length === 0) {
      return;
    }

    const ltp = parseFloat(symbolData[selectedSymbol?.code]?.ltp);
    const riskFreeRate = 0.064515;
    const updatedSelectedData = [...selectedData];

    updatedSelectedData.forEach((item) => {
      const strike = item.strike;
      const optionType = item.isCALL ? "call" : "put";
      const expiryDateTimeStr = item.expiry + " 15:29:59";
      const expiryDate = new Date(expiryDateTimeStr);
      const currentDate = new Date();

      let timeToExpiration = Math.max(
        0,
        (expiryDate - currentDate) / (24 * 60 * 60 * 365 * 1000) || 0.0002 / 365
      );

      const currentStockPrice = item.price
        ? parseFloat(item.price)
        : parseFloat(symbolData[item.code]?.ltp);

      const initialGuessIv = iv.getImpliedVolatility(
        currentStockPrice,
        ltp,
        strike,
        timeToExpiration,
        riskFreeRate,
        optionType
      );

      if (initialGuessIv <= 1) {
        const ivValue = (initialGuessIv * 100).toFixed(2);
        const deltaValue = greeks
          .getDelta(
            ltp,
            strike,
            timeToExpiration,
            initialGuessIv,
            riskFreeRate,
            optionType
          )
          .toFixed(2);
        const thetaValue = greeks
          .getTheta(
            ltp,
            strike,
            timeToExpiration,
            initialGuessIv,
            riskFreeRate,
            optionType
          )
          .toFixed(2);
        const gammaValue = greeks
          .getGamma(
            ltp,
            strike,
            timeToExpiration,
            initialGuessIv,
            riskFreeRate,
            optionType
          )
          .toFixed(4);
        const vegaValue = greeks
          .getVega(
            ltp,
            strike,
            timeToExpiration,
            initialGuessIv,
            riskFreeRate,
            optionType
          )
          .toFixed(2);
        const rhoValue = greeks
          .getRho(
            ltp,
            strike,
            timeToExpiration,
            initialGuessIv,
            riskFreeRate,
            optionType
          )
          .toFixed(2);

        item.iv = ivValue;
        item.delta = deltaValue;
        item.theta = thetaValue;
        item.gamma = gammaValue;
        item.vega = vegaValue;
        item.rho = rhoValue;
      }
    });

    setCurrentOptionsCopy(updatedSelectedData);
  };

  // useEffect(() => {
  //   handleStrategyOnSymbolChange();
  // }, [optionData]);

  useLayoutEffect(() => {
    setGreeksJson();
    computeGreeks();
  }, [selectedData, symbolData, currentOptionsData]);

  // useLayoutEffect(() => {
  //   updateSelectedDataGreeks();
  // }, [selectedData, optionData]);

  // const updateSelectedDataGreeks = () => {
  //   selectedData.map((row, index) => {
  //     const option_index = optionData.options.findIndex(
  //       (jsonObj) => jsonObj.strike === row.strike
  //     );
  //     if (option_index != -1) {
  //       let optiondata = row.isCALL
  //         ? optionData.options[option_index].call
  //         : optionData.options[option_index].put;
  //       let delta = optiondata?.delta;
  //       let theta = optiondata?.theta;
  //       let gamma = optiondata?.gamma;
  //       let vega = optiondata?.vega;
  //       if (!row.isBuy) {
  //         delta = -delta;
  //         theta = -theta;
  //         vega = -vega;
  //         gamma = -gamma;
  //       }
  //       optiondata.delta = delta;
  //       optiondata.theta = theta;
  //       optiondata.gamma = gamma;
  //       optiondata.vega = vega;
  //     }
  //   });
  // };

  // Extracting strike
  const extractStrikeValues = (optionData) => {
    if (!optionData || !Array.isArray(optionData.options)) {
      return [];
    }
    return optionData.options?.map((options) => options?.strike);
  };

  const handleOKClick = async (isVirtual) => {
    const payload = generateOrderPayload({
      isVirtual: isVirtual,
      selectedData,
      marketType,
      limitOrderStates,
      selectedSymbol,
      broker,
      access_token,
      client_id,
    });
    try {
      const response = await sendOrder(payload, isVirtual);
      // clearBasket();
      fetchBalanceAPI();
      if (response.status) {
        toast.success(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-success-toast",
            icon: <img src={SuccessIcon} alt="Success Icon" />,
            onClick: () => handleToastToNavigate(response),
          }
        );
      } else {
        toast.error(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-error-toast",
            icon: <img src={ErrorIcon} alt="Error Icon" />,
          }
        );
      }
    } catch (error) {
      console.error("Error handling order:", error);
      toast.error(
        <CustomToastContent
          heading="Error handling order"
          message={error.message}
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
    }
  };

  const [overallMargin, setOverallMargin] = useState(null);
  const [finalMargin, setFinalMargin] = useState(null);
  const [hedgeBenefits, setHedgeBenefits] = useState(null);
  const [marginRequired, setMarginRequired] = useState(null);
  const [charges, setCharges] = useState(null);
  const marginEffectRunRef = useRef(0);

  // marginRequired api call
  useLayoutEffect(() => {
    const runId = ++marginEffectRunRef.current;
    let isCancelled = false;
    const isActiveRun = () =>
      !isCancelled && marginEffectRunRef.current === runId;

    const generateMarginPayload = () => {
      const orderList = selectedData.map((currData, ind) => {
        const price =
          currData.hasOwnProperty("price") && currData.price
            ? currData.price
            : symbolData[currData.code]?.ltp;

        return {
          isBuy: currData.isBuy,
          isCall: currData.isCALL,
          isFut: false,
          code: currData.code,
          exchange: currData.exchange,
          productType: marketType === "NRML" ? "NRML" : "MIS",
          orderType: !limitOrderStates?.[selectedSymbol?.scrip]?.[ind]
            ? "MARKET"
            : "LIMIT",
          quantity: currData.lotSize * currData.lot_multiplier,
          price,
          strike: currData.strike,
          expiry: currData.expiry,
          tradingSymbol: currData.tradingSymbol,
          lot_multiplier: currData.lot_multiplier,
          scrip: currData.scrip,
        };
      });

      return {
        order_list: orderList,
        broker,
        access_token,
        client_id,
      };
    };

    const hasUndefinedPrice = (payload) =>
      payload.order_list.some((order) => order.price === undefined);

    const fetchWithRetry = async (
      requestFn,
      isDataReady,
      maxAttempts = 3,
      delayMs = 200
    ) => {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        try {
          const response = await requestFn();
          if (isDataReady(response?.data)) {
            return response;
          }
        } catch (error) {
          if (attempt === maxAttempts - 1) throw error;
        }
        await new Promise((resolve) => setTimeout(resolve, delayMs));
      }
      return null;
    };

    const fetchMarginRequired = async () => {
      const payload = generateMarginPayload();
      if (hasUndefinedPrice(payload)) {
        // Wait for next state update when prices are available.
        return;
      }

      try {
        const response = await fetchWithRetry(
          () =>
            axios.post(
              "https://7mwh6csmrh.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_margin",
              payload
            ),
          (data) => data?.finalMargin != null
        );
        if (!response || !isActiveRun()) {
          return;
        }
        setMarginRequired(response.data?.finalMargin);
        setOverallMargin(response.data?.marginAvailable);
        setFinalMargin(response.data?.finalMargin);
        setHedgeBenefits(response.data?.hedge_benefit);
      } catch (error) {
        console.error("Error getting margin required:", error);
      }
    };

    const fetchCharges = async () => {
      const payload = generateMarginPayload();
      if (hasUndefinedPrice(payload)) {
        // Wait for next state update when prices are available.
        return;
      }

      try {
        const response = await fetchWithRetry(
          () =>
            axios.post(
              "https://pc933vy3c6.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_charges",
              payload
            ),
          (data) => data?.total_charges != null
        );
        if (!response || !isActiveRun()) {
          return;
        }
        setCharges(response.data?.total_charges);
      } catch (error) {
        console.error("Error getting charges:", error);
      }
    };

    if (selectedData?.length > 0) {
      fetchMarginRequired();
      fetchCharges();
    }
    if (selectedData?.length === 0) {
      if (!isActiveRun()) {
        return;
      }
      setMarginRequired(null);
      setOverallMargin(null);
      setFinalMargin(null);
      setHedgeBenefits(null);
    }
    return () => {
      isCancelled = true;
    };
  }, [selectedData, marketType, limitOrderStates]);

  const handleAddNewRow = () => {
    if (selectedData.length === 0) {
      handleMarketTypeChange("NRML");
      const newRow = {
        isBuy: true, // Default to Buy
        expiry: "", // Default empty expiry
        strike: "", // Default empty strike
        isCALL: true, // Default to CE
        lotSize: 1, // Default lot size
        price: "",
      };
      const scrip = selectedSymbol.scrip;
      setRows((prev) => {
        return {
          ...prev,
          [scrip]: newRow,
        };
      });
      setData([newRow]);
      return;
    }
    let childData = applyPreBuiltStrategy("buy_call");
    handleCallback([childData], true);
  };

  const handleAddNewStrategyClick = () => {
    handleLotxChange(1);
    handleMarketTypeChange("NRML");
    let childData = applyPreBuiltStrategy("buy_call");
    handleCallback([childData]);
  };
  const [sumGreeksValue, setSumGreeksValue] = useState({
    theta: 0,
    gamma: 0,
    delta: 0,
    vega: 0,
    rho: 0,
  });
  useEffect(() => {
    // Ensure greeksData is an array
    if (!Array.isArray(allOptionData)) {
      // console.warn("greeksData is not an array:", greeksData);
      return; // Exit early if greeksData is not an array
    }

    let theta = 0;
    let gamma = 0;
    let delta = 0;
    let vega = 0;
    let rho = 0;
    allOptionData.forEach((greek) => {
      theta += parseInt(greek.theta) || 0;
      gamma += parseFloat(greek.gamma) || 0;
      delta += parseInt(greek.delta) || 0;
      vega += parseInt(greek.vega) || 0;
      rho += parseInt(greek.rho) || 0;
    });

    gamma = gamma.toFixed(2);

    setSumGreeksValue({
      theta,
      gamma,
      delta,
      vega,
      rho,
    });

    // console.log("Updated Greeks:", theta, gamma, delta, vega, rho);
  }, [selectedData, allOptionData]);

  const showConfirmModal = () => {
    // Validate that all Limit orders have prices
    const limitOrdersWithoutPrice = selectedData.filter((row, index) => {
      const isLimitOrder = row.orderType === "L";
      const hasEmptyPrice = !row.price || row.price === "" || row.price === null;
      return isLimitOrder && hasEmptyPrice;
    });

    if (limitOrdersWithoutPrice.length > 0) {
      toast.error(
        <CustomToastContent
          heading="Price cannot be empty"
          message="Please enter a price for all Limit orders before executing."
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
      return;
    }

    setShowConfirm(true);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLtp, setCurrentLtp] = useState(null);
  const [atmIndexData, setAtmIndexData] = useState({});
  const [ltptoiv, setLtpToIv] = useState(0);

  useEffect(() => {
    if (!selectedData || selectedData.length === 0) return;
    const trySetLtp = () => {
      if (selectedSymbol?.code && symbolData[selectedSymbol.code]) {
        setCurrentLtp(symbolData[selectedSymbol?.code]?.ltp);
      } else {
        setTimeout(trySetLtp, 200);
      }
    };
    trySetLtp();
    const atmIndex = returnAtmIndex();
    const callOption =
      currentOptionsData[selectedExpiry]?.options[atmIndex]?.call;
    const ltpToIv = symbolData[callOption?.code]?.ltp;
    setLtpToIv(ltpToIv);
    setAtmIndexData(callOption);
    // console.log(callOption, "callOption", ltpToIv);
  }, [selectedData, selectedExpiry]);

  function returnAtmIndex() {
    let index = 0;
    const ltp = symbolData[selectedSymbol?.code]?.ltp || 0;

    if (
      currentOptionsData[selectedExpiry] &&
      currentOptionsData[selectedExpiry].options &&
      currentOptionsData[selectedExpiry].options?.length > 0
    ) {
      let optionData = currentOptionsData[selectedExpiry].options;
      let curr = parseFloat(optionData[0].strike);
      let diff = Math.abs(ltp - curr);

      for (let val = 0; val < optionData.length; val++) {
        const strike = parseFloat(optionData[val].strike);
        const newDiff = Math.abs(ltp - strike);

        if (newDiff < diff) {
          diff = newDiff;
          curr = strike;
          index = val;
        }
      }
    }

    return index;
  }

  useEffect(() => {
    if (
      currentOptionsData[selectedExpiry] &&
      currentOptionsData[selectedExpiry]["options"]?.length > 0
    ) {
      let underlying_ltp = symbolData[selectedSymbol?.code]?.ltp;
      let data = { ...currentOptionsData[selectedExpiry] };
      const formattedData = data["options"]?.map((item) => ({
        ...item,
        strike: parseInt(item.strike),
      }));

      // If symbolData is not available yet, use the first strike as default
      let closestIdx = 0;
      if (underlying_ltp) {
        let minDiff = Math.abs(
          formattedData[0]?.strike - parseFloat(underlying_ltp)
        );

        // Iterate through the array to find the closest index
        formattedData.forEach((item, index) => {
          const diff = Math.abs(item.strike - parseFloat(underlying_ltp));
          if (diff < minDiff) {
            minDiff = diff;
            closestIdx = index;
          }
        });
      }

      const userSelectedStrikes = configureSettingsMap.noOfStrikes;
      const half = Math.floor(userSelectedStrikes);
      // const half = Math.floor(configureSettingsMap.noOfStrikes);
      // console.log(half);
      const selected = formattedData.slice(
        Math.max(0, closestIdx - half),
        Math.min(formattedData.length, closestIdx + half + 1)
      );
      data["options"] = selected;
      setOptionData(data);
      // setTempOptionData(data);
      const call = getCodeTradingSymbolMappings(selected, "call");
      const put = getCodeTradingSymbolMappings(selected, "put");
      let callsdata = data?.options?.map((option) => option?.call);
      let putsdata = data?.options?.map((option) => option?.put);
      setCalls(callsdata);
      setPuts(putsdata);
      const tradingSymbols = call.concat(put);
      setAllTradingSymbols(tradingSymbols);
      subscribeToSymbols(tradingSymbols, data?.options[0]?.call?.exchange);
    }
  }, [currentOptionsData, selectedExpiry, configureSettingsMap.noOfStrikes, symbolData]);

  // maxStrikes updated without overriding noOfStrikes
  useEffect(() => {
    if (currentOptionsData[selectedExpiry]?.options) {
      const totalStrikes = currentOptionsData[selectedExpiry].options.length;
      if (configureSettingsMap.maxStrikes !== totalStrikes) {
        setConfigureSettingsMap((prev) => ({
          ...prev,
          maxStrikes: totalStrikes,
        }));
      }
    }
  }, [currentOptionsData[selectedExpiry], configureSettingsMap.maxStrikes]);
  const { symbol } = useParams();
  return (
    <>
      <Helmet>
        <title>OptionChain</title>
      </Helmet>
      <div className="grid grid-cols-8 gap-4 pt-10">
        {isOverlayActive && <div className="overlay"></div>}

        {!isExpanded && (
          <div className="col-span-3 mt-3 mb-5">
            <Tabs preSelectedSymbol={symbol} />
            <Basket
              currentRows={selectedData}
              handleAddNewRow={handleAddNewRow}
              handleAddNewStrategyClick={handleAddNewStrategyClick}
              charges={charges}
              showConfirmModal={showConfirmModal}
              computedData={computedData}
            />
            <ConfirmStrategyModal
              isOpen={showConfirm}
              onCancel={() => setShowConfirm(false)}
              onConfirm={() => {
                setShowConfirm(false);
                handleOKClick(broker == "aliceblue" ? false : true);
              }}
            />
            <MarginAndFundsCard
              marginRequired={marginRequired}
              finalMargin={finalMargin}
              hedgeBenefits={hedgeBenefits}
              marginAvailable={fundsData.marginAvailable}
              formatNumberWithCommasAndFontWeight={
                formatNumberWithCommasAndFontWeight
              }
            />
            <div className="text-[14px] text-p300 font-semibold pb-[10px] mt-4">
              Payoff Simulations
            </div>
            <PayoffSimulations data={computedData} />
          </div>
        )}
        <div className={`${isExpanded ? 'col-span-8 flex flex-col h-[calc(100vh-96px)]' : 'col-span-5 mt-4 mb-5'}`}>
          {isExpanded ? (
            <div className="flex justify-between items-end shrink-0 pb-2">
              <div className="w-[37.5%]">
                <Tabs />
              </div>
              <div className="flex gap-2 items-center">
                <button
                  onClick={() => setIsExpanded(false)}
                  className="flex items-center justify-center w-8 h-8 rounded-md bg-p400 text-p300 hover:bg-p400/80 transition-colors"
                  title="Collapse"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="4 14 10 14 10 20" />
                    <polyline points="20 10 14 10 14 4" />
                    <line x1="14" y1="10" x2="21" y2="3" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>
                <ExpiryDropdown
                  expiry={selectedExpiry}
                  expiries={selectedSymbol?.option_expiries}
                  onSelect={(selected) => {
                    setSelectedExpiry(selected);
                  }}
                  label="Exp:"
                />
                <Configure
                  configureSettingsMap={configureSettingsMap}
                  setConfigureSettingsMap={setConfigureSettingsMap}
                />
              </div>
            </div>
          ) : (
            <div className="flex justify-between items-center mb-2">
              <div></div>
              <div className="flex gap-2 items-center">
                <button
                  onClick={() => setIsExpanded(true)}
                  className="flex items-center justify-center w-8 h-8 rounded-md bg-p400 text-p300 hover:bg-p400/80 transition-colors"
                  title="Expand"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 3 21 3 21 9" />
                    <polyline points="9 21 3 21 3 15" />
                    <line x1="21" y1="3" x2="14" y2="10" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>
                <ExpiryDropdown
                  expiry={selectedExpiry}
                  expiries={selectedSymbol?.option_expiries}
                  onSelect={(selected) => {
                    setSelectedExpiry(selected);
                  }}
                  label="Exp:"
                />
                <Configure
                  configureSettingsMap={configureSettingsMap}
                  setConfigureSettingsMap={setConfigureSettingsMap}
                />
              </div>
            </div>
          )}
          <div className={isExpanded ? 'flex-1 overflow-y-auto' : ''}>
            {!configureSettingsMap.showCalls && !configureSettingsMap.showPuts ? (
              <div className=" w-full h-[500px] bg-p400 text-n500 rounded-md text-[14px] text-center flex justify-center items-center py-6">
                Enable Calls or Puts to view data
              </div>
            ) : optionData?.options ? (
              <OptionChainTable
                handleLotxChange={handleLotxChange}
                optionData={optionData}
                options={optionData?.options}
                showCalls={configureSettingsMap.showCalls}
                showPuts={configureSettingsMap.showPuts}
                calls={calls}
                puts={puts}
                parentCallback2={handleCallback2}
                clickEnable={true}
                symbol={selectedSymbol}
                showDelta={configureSettingsMap.showDelta}
                showGamma={configureSettingsMap.showGamma}
                showVega={configureSettingsMap.showVega}
                showTheta={configureSettingsMap.showTheta}
                showRho={configureSettingsMap.showRho}
                showOIChng={configureSettingsMap.showOIChng}
                showOIBuilddup={true}
                isScalpOrderChecked={true}
                isFromCharts={isExpanded}
                isExpanded={isExpanded}
                maxPain={maxPain}
                selectedDate={activeDate}
                setObjectData={setObjectData}
                objectData={objectData}
                selectedData={selectedData}
              />
            ) : (
              <div>Loading data...</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OptionChainScreen;
